<template>
  <div class="orall">
    <div class="order">
      <div class="top">本站暂仅提供百度云链接</div>
      <ordersListOne :tabledata="ordersdata"></ordersListOne>
      <div class="bigqr" v-if="alipayUrl != null">
        <div class="qr">
          <div class="givepay" @click="handleBigqrClick">放弃</div>
          <div class="countdown">有效时: {{ timeRemaining }} </div>
          <canvas ref="qrcodeCanvas" class="qrcode"></canvas>
          <div class="tshi">使用支付宝</div>
        </div>
      </div>
      <div class="pay" v-if="totalPrice <= 0" @click="chosPay()">添加</div>
      <div class="pay" v-if="totalPrice > 0" @click="chosPay()">{{ totalPrice }}灵石</div>
    </div>
  </div>

</template>

<script>
import QRCode from 'qrcode'
import ordersListOne from '@/components/ordersListOne.vue'

export default {
  name: 'order',
  components: {
    ordersListOne
  },
  props: ['posMsg'],
  data() {
    return {
      timeRemaining: null, // 初始倒计时时间
      alipayUrl: null, // 支付宝支付链接
      ordersdata: [],
      orderData: {
        type: 'alipay', //支付类型
        out_trade_no: '', //订单号
        money: 0, //付款金额
      },
    }
  },
  computed: {
    // 计算属性：自动计算总价格
    totalPrice() {
      return this.ordersdata.reduce((total, order) => {
        const price = order.price;
        return total + price;
      }, 0);
    }
  },
  watch: {
    totalPrice(newPrice) {
      this.orderData.money = newPrice; // 通过 watch 监听 totalPrice 更新 orderData.money
    },
    posMsg(posMsg) {
      if (posMsg === '100vw') {
        this.getGoods();  // 当 posMsg 为 '100vw' 时调用 getGoods 方法
      }
    }
  },
  created() {
    this.getGoods()
  },
  methods: {
    async getGoods() {
      try {
        const userInfo = this.getUserInfo();
        const response = await this.$axios.get(`/orders/list?userid=${userInfo.id}`);

        if (response.data.status === 200) {
          this.ordersdata = response.data.results.reverse();
        }
      } catch (err) {
        console.error('Error fetching orders:', err);
      }
    },

    getUserInfo() {
      return JSON.parse(localStorage.getItem('userInfo')) || {};
    },

    chosPay() {
      if (this.totalPrice === 0) {
        this.orderPay();
      } else if (this.totalPrice > 1800) {
        alert('单次最高1800');
      } else {
        this.submitOrder();
      }
    },

    async orderPay() {
      try {
        const userInfo = this.getUserInfo();
        const response = await this.$axios.post('/orders/addmybuys', { userid: userInfo.id });

        if (response.data.status === 200) {
          console.log('Order successfully placed');
        }
        this.getGoods(); // Re-fetch the orders after placing the order
      } catch (err) {
        console.error('Error placing order:', err);
      }
    },

    async submitOrder() { //支付宝支付方法
      try {
        const userInfo = this.getUserInfo();
        const chinaTime = Math.floor(Date.now() / 1000).toString();
        this.orderData.out_trade_no = chinaTime + userInfo.id;
        // console.log(this.orderData.out_trade_no)

        const response = await this.$axios.post('/orders/create_order', {
          out_trade_no: this.orderData.out_trade_no,
          subject: 'JavaScript',
          total_amount: this.orderData.money,
        });

        if (response.data.success) {
          this.alipayUrl = response.data.qr_code_url;
          this.generateQRCode();  //调用二维码生成函数
          this.setupWebSocket();  //调用websocket连接，获取回调信息
        } else {
          alert('订单创建失败');
        }
      } catch (error) {
        console.error('Error creating order:', error);
      }
    },

    generateQRCode() {  //生成二维码
      this.$nextTick(() => {  // 确保在dom加载完后生成
        const canvas = this.$refs.qrcodeCanvas;
        if (canvas) {
          QRCode.toCanvas(canvas, this.alipayUrl, (error) => {
            if (error) {
              console.error('二维码生成失败:', error);
            } else {
              this.timeRemaining = 120;
              this.startCountdown();
              // console.log('二维码生成成功！');
            }
          });
        } else {
          console.error('Canvas element not found');
        }
      });
    },

    // 设置 WebSocket 连接
    setupWebSocket() {
      // 连接到 WebSocket 服务端
      // this.ws = new WebSocket('ws://localhost:8080'); // WebSocket 服务器地址和端口
      this.ws = new WebSocket('wss://www.handingszy.top:8080'); // WebSocket 服务器地址和端口,如果服务器域名部署了ssl安全证书，则必须使用wss

      // 监听连接成功事件
      this.ws.onopen = () => {
        console.log('WebSocket connected!');
      };

      // 监听服务器消息
      this.ws.onmessage = (event) => {
        const message = JSON.parse(event.data); // 解析服务器返回的消息
        console.log('Received message:', message);

        // 检查是否为支付成功的回调
        if (message.status === 'success') {
          console.log(this.alipayUrl)
          if (message.orderNumber == this.orderData.out_trade_no) {
            // 清空 alipayUrl
            this.alipayUrl = null;

            // 调用 orderPay 函数
            this.orderPay();

            this.closeWebSocket();
          } else {
            console.log('订单号不对')
          }
        }
      };

      // 监听连接关闭事件
      this.ws.onclose = () => {
        console.log('WebSocket disconnected!');
      };

      // 监听错误事件
      this.ws.onerror = (error) => {
        alert('连接失败，请勿支付')
        console.error('WebSocket Error:', error);
      };
    },

    // 关闭 WebSocket 连接
    closeWebSocket() {
      if (this.ws) {
        this.ws.close();
        console.log('WebSocket connection closed');
      }
    },

    handleBigqrClick() {
      this.alipayUrl = null;
      this.closeWebSocket();
    },

    //计时
    startCountdown() {
      const countdown = setInterval(() => {
        if (this.timeRemaining <= 0) {
          clearInterval(countdown); // 清除定时器
          this.timeRemaining = '已失效';
        } else {
          this.timeRemaining--; // 每秒减少1秒
        }
      }, 1000);
    }
  }
}
</script>

<style scoped lang="scss">
.orall {
  width: 100%;
  height: 100%;
  position: relative;

  .order {
    width: 100%;
    height: 100%;
    // background-color: rgba(240, 248, 255, 0.5);
    background: url(../../assets/beijing2.jpg) center/100%;
    overflow: auto;
    padding-bottom: 8vh;

    .top {
      width: 100%;
      height: 200rem;
      background-color: rgba(255, 228, 196, 0.5);
      text-align: center;
      line-height: 200rem;
      font-size: 80rem;
      font-weight: 800;
      color: red;
    }

    .bigqr {
      width: 100%;
      height: 100%;
      position: fixed;
      z-index: 1000;
      left: 0;
      top: 0;
      background-color: rgba(0, 0, 0, 0.4);

      .qr {
        position: relative;
        background-color: rgba(255, 255, 255, 0.5);
        margin: 30vh auto;
        border: 1rem solid #888;
        width: 40vh;
        height: 40vh;
        z-index: 1001;
        overflow: hidden;
        text-align: center;

        .givepay {
          width: 100%;
          height: 15%;
          color: aliceblue;
          background-color: #3f3f3f;
          border-bottom: 1rem solid black;
          font-size: 4vh;
        }

        .countdown {
          width: 100%;
          height: 15%;
          color: aliceblue;
          background-color: #3f3f3f;
          border-bottom: 1rem solid black;
          font-size: 4vh;
        }

        .tshi {
          width: 100%;
          color: rgb(255, 255, 255);
          font-size: 2vh;
          line-height: 0vh;
        }
      }
    }

    .pay {
      width: 100%;
      height: 8vh;
      background-color: rgb(11, 35, 255);
      border: 2rem solid gray;
      position: absolute;
      bottom: 0;
      font-size: 3vh;
      text-align: center;
      line-height: 8vh;
      color: rgb(255, 238, 125);
      font-weight: 800;
    }
  }

  .order::-webkit-scrollbar {
    display: none;
  }
}
</style>